
<div class="claroAlert_container" [ngClass]="cssContainerClass" [class.is-mobile-view]="isMobileView">

    <div class="claroAlert_dataSide">

        <mat-icon *ngIf="!hideIcon" class="claroAlert_icon">{{ icon }}</mat-icon>

        <div class="claroAlert_message" [ngClass]="cssContainerClass">
            <span *ngIf="!hideHeader" class="claroAlert_messageHeader">{{ header }}</span>
            <span class="claroAlert_messageText">{{ text }}</span>
        </div>

    </div>

    <div class="claroAlert_actionSide" [class.is-mobile-view]="isMobileView">

        <button *ngIf="presentDismissButton && dismissButtonText" mat-stroked-button class="claroAlert_secondaryButton" [style.color]="textColor" (click)="onDismissAlertClicked()">{{ dismissButtonText }}</button>
        <button *ngIf="presentDetailsButton" mat-stroked-button class="claroAlert_detailsButton" [style.color]="textColor" (click)="onSeeAlertClicked()">{{detailsButtonText}}</button>
        <button *ngIf="presentDismissButton && !dismissButtonText" mat-icon-button class="claroAlert_dismissButton" [style.color]="textColor" (click)="onDismissAlertClicked()">
            <mat-icon>close</mat-icon>
        </button>

    </div>

</div>
